export default "__VITE_ASSET__BYQJDiHz__"